let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gftgT")).then(() => parcelRequire('i0bIF'));